import { render, staticRenderFns } from "./taskListPop.vue?vue&type=template&id=36a50694&"
import script from "./taskListPop.vue?vue&type=script&setup=true&lang=js&"
export * from "./taskListPop.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./taskListPop.vue?vue&type=style&index=0&id=36a50694&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports